module.exports = __webpack_public_path__ + "static/media/2.ee39f59c.jpg";